<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="copy-content-article-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Copy Article
            </h4>
          </div>

          <div class="modal-body" v-if="!loading">
            <SelectFormGroup
                v-model="data.portal_id"
                name="portal_id"
                label="Portal"
                :options="portals.map(portal => ({value: portal.id, label: portal.attributes.name}))"
            />

            <SelectFormGroup
                v-if="data.portal_id"
                v-model="data.content_article_category_id"
                name="content_article_category"
                label="Content Article Category"
                :error="(errors.content_article_category_id || [])[0]"
                :options="contentArticleCategoryOptions"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'

export default {
  components: {SelectFormGroup},

  props: {
    contentArticle: {
      required: true
    }
  },

  data() {
    return {
      data: {},

      portals: null,
      contentArticleCategories: null,

      loading: true,
      errors: {}
    }
  },

  watch: {
    'data.portal_id'() {
      this.data.content_article_category_id = null
    }
  },

  mounted() {
    this.listenForClose()

    this.load()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    load() {
      Promise.all([
        http.get('/api/v2/portals', {'page_size': 100}),
        http.get('/api/v2/content-article-categories', {'page_size': 100}),
      ]).then(responses => {
        this.portals = responses[0].data.data

        this.contentArticleCategories = responses[1].data.data

        this.loading = false
      })
    },

    submit() {
      http.post('/api/v2/content-articles/' + this.contentArticle.id + '/copy', this.data)
          .then(response => {
            notify.success('The article was copied')

            this.$emit('copied', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  },

  computed: {
    contentArticleCategoryOptions() {
      return this.contentArticleCategories
          .filter(contentArticleCategory => contentArticleCategory.attributes.portal_id.toString() === this.data.portal_id)
          .map(contentArticleCategory => ({
            value: contentArticleCategory.id,
            label: contentArticleCategory.attributes.name
          }))
    }
  }
}
</script>
